const content = {
    src: require('./SRWFM005.jpg'),
    title: 'Arts',
    content: 'For nearly a decade, the Environmental Peacebuilding Community of Practice has been critically examining the environment\'s role in peace and conflict, advocating for the productive potential of environmental justice and natural resource governance to contribute to a sustainable peace. Bringing a new lens to these intersections, the Environmental Peacebuilding Association is now launching an initiative to explore how art can inform, celebrate, and teach environmental peacebuilding scholarship and practice.',
}

export default content;